import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { HttpService } from './services/http/http.service';
import { UtilFunctions } from './util/util';
import { ClearStoreFunction } from './core/store/clearStore';
import { LoggerService } from './services/logger/logger.service';
import { BASE_CONFIG } from './util/base-settings';
import { PLATFORM, SESSION_STORAGE_KEYS } from './util/constants';
import { selectRememberLogin } from './store/auth/auth.selectors';
import { RememberLoginStorageAction, TokenStorageAction } from './store/auth/auth.actions';
import { SharedModule } from './shared/shared.module';
import { ExceptionHandler } from './util/error-handler';

@Component({
  selector: 'ngx-app',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
@ExceptionHandler
export class AppComponent
{

  showLoading$: Observable<boolean>;
  isPrgrsCompleted: any;
  isProgress: boolean;

  constructor(
    private httpService: HttpService,
    private util: UtilFunctions,
    private storeClear: ClearStoreFunction,
    private store: Store,
    private _logger: LoggerService
  )
  {
    this.initializeApp();
    util.addIonIcons();
  }


  ngAfterViewInit()
  {
    this.httpService.dataSubject.subscribe(res =>
    {
      this.isProgress = null;
      this.isProgress = res;
    });


    // this.cdr.detectChanges();
  }


  ngOnInit(): void
  {

  }


  async initializeApp()
  {
    if (BASE_CONFIG.IS_DEBUG) console.log('initializeApp', BASE_CONFIG.VERSION);
    this.processLoggedInData();
    this.storeClear.forceClearLocalStorage();

    BASE_CONFIG.BROWSER = this.util.getBrowserName();

    if (PLATFORM.web == BASE_CONFIG.PLATFORM)
    {
      document.body.className = 'web';
    } else
    {
      document.body.className = 'app';
      // require("../assets/app.scss");
    }
    // document.body.className = platform;


  }


  processLoggedInData()
  {
    if (BASE_CONFIG.IS_DEBUG) console.log('processLoggedInData');
    if (!window.sessionStorage.getItem(SESSION_STORAGE_KEYS.NEW_SESSION))
    {
      window.sessionStorage.setItem(SESSION_STORAGE_KEYS.NEW_SESSION, '1');

      let isOnceEntered = false;
      let sLogin = this.store.select(selectRememberLogin()).subscribe((isRememberMe) =>
      {
        if (!isOnceEntered && !isRememberMe)
        {
          isOnceEntered = true;
          this.store.dispatch(new TokenStorageAction(null));
          this.store.dispatch(new RememberLoginStorageAction(true));
        }
      });
      sLogin.unsubscribe();
    }
  }

}
